var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-single-collapse',{staticClass:"rounded-lg",attrs:{"button-text":"Instructions","expanded":_vm.expanded}},[_vm._t("default",function(){return [_vm._v("Default slot here")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }